import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { EarthLoader } from '../../components/loaders/EarthLoader';
import { PageContent } from '../../components/page/PageContent';
import { PageHeader } from '../../components/page/PageHeader';
import { UserContext } from '../../contexts/UserContext';
import { OrganisationBillingInfo } from '../../modules/organisation/OrganisationBillingInfo';
import { OrganisationCompanyInfo } from '../../modules/organisation/OrganisationCompanyInfo';
import { T } from '../../translation/src';
import { useOrganisationsQuery } from '../../types/graphqlTypes';

export const CompanyInfo: React.FC2 = () => {
  const user = useContext(UserContext);
  const { organisationId = '' } = useParams();
  const { loading } = useOrganisationsQuery(user ? { variables: { includeIds: [organisationId] } } : {});

  return (
    <PageContent>
      <PageHeader title={<T _str="organisation" swc />} />

      <div className="w-full min-h-0 flex-1 overflow-y-auto">
        {loading ? (
          <EarthLoader />
        ) : (
          <div className="flex flex-col w-full space-y-4 pb-10">
            <OrganisationCompanyInfo />
            <OrganisationBillingInfo />
          </div>
        )}
      </div>
    </PageContent>
  );
};
